import { render, staticRenderFns } from "./ReturnPartsSideMenu.vue?vue&type=template&id=77493946"
import script from "./ReturnPartsSideMenu.vue?vue&type=script&lang=js"
export * from "./ReturnPartsSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77493946')) {
      api.createRecord('77493946', component.options)
    } else {
      api.reload('77493946', component.options)
    }
    module.hot.accept("./ReturnPartsSideMenu.vue?vue&type=template&id=77493946", function () {
      api.rerender('77493946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnparts/ReturnPartsSideMenu.vue"
export default component.exports